export const localConfig = {
  REACT_APP_AZURE_CLIENT_ID: '************************',
  REACT_APP_API_URL: 'https://localhost:7006',
  Document_API_URL: 'http://localhost:7246', //'https://as-mg-dev1-t1-weu-invdesktop-api-01.azurewebsites.net',
  REACT_APP_AZURE_REDIRECT_URL: 'https://localhost:3000',
  REACT_APP_AZURE_AUTHORITY:
    'https://login.microsoftonline.com/aa42167d-6f8d-45ce-b655-d245ef97da66',
  REACT_APP_AZURE_SCOPE: 'api://2f491c08-9985-4b7d-a6b9-f60eaf33afb3/user_impersonation',
  APP_INSIGHTS_INSTRUMENTATIONKEY: '*************************',
  ApplicationId: '147',
  BlobConnectionString:
    'https://mgredmsstorageaccountuat.blob.core.windows.net/dmsfiles?sp=rawd&st=2025-06-17T14:54:57Z&se=2025-07-12T22:54:57Z&sv=2024-11-04&sr=c&sig=eT0QhQ4Qf9jfex8v11GX0pcL3GT8W98SgtpGEu6enjk%3D',
  ContainerName: 'dmsfiles',
  StorageAccountName: 'mgredmsstorageaccountuat'
}

export const getConfig = () => {
  if (process.env.NODE_ENV === 'development') {
    return localConfig
  } else {
    return window.config
  }
}
